// voices.js - Structured database of standard & premium neural voice models

export const VOICE_DATABASE = [
  // ── AMERICAN ENGLISH ──
  {
    value: "Lessac",
    name: "Lessac",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Warm, rich and highly natural American female voice.",
    sentence: "The journey of a thousand miles begins with a single step.",
    compatibility: "XTTS v2, VITS",
    popularity: 98,
    rating: 4.9,
    duration: "15s",
    useCases: "Documentaries, Audiobooks",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Amy",
    name: "Amy",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Conversational",
    quality: "Human-like",
    desc: "Clear, conversational and friendly American female tone.",
    sentence: "Hello! How can I help you navigate your dashboard today?",
    compatibility: "XTTS v2",
    popularity: 96,
    rating: 4.8,
    duration: "12s",
    useCases: "AI Assistants, E-Learning",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Jenny",
    name: "Jenny",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Podcast",
    quality: "Premium",
    desc: "Soft, engaging and professional voice.",
    sentence: "Welcome back to another episode. Today we are diving deep into voice synthesis.",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.7,
    duration: "18s",
    useCases: "Podcasts, YouTube Videos",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Emily",
    name: "Emily",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Audiobook",
    quality: "Studio",
    desc: "Calm, expressive reader ideal for storytelling.",
    sentence: "The stars shone brightly in the quiet, mysterious midnight sky.",
    compatibility: "XTTS v2, VITS",
    popularity: 92,
    rating: 4.8,
    duration: "20s",
    useCases: "Audiobooks, Storytelling",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Sophia",
    name: "Sophia",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Expressive",
    desc: "Warm and inviting tone for professional presentations.",
    sentence: "Let us review our quarterly results and plan for future success.",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.8,
    duration: "14s",
    useCases: "Corporate Training, Commercials",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Olivia",
    name: "Olivia",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Friendly",
    quality: "Premium",
    desc: "Energetic and social media-oriented female voice.",
    sentence: "Here are three simple tips to scale your startup in 2026!",
    compatibility: "XTTS v2",
    popularity: 97,
    rating: 4.9,
    duration: "10s",
    useCases: "TikTok, YouTube Shorts, Commercials",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Ava",
    name: "Ava",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Conversational",
    quality: "Human-like",
    desc: "Happy, pleasant, and helpful conversational voice.",
    sentence: "I'm so excited to share this amazing tutorial with all of you today.",
    compatibility: "XTTS v2, VITS",
    popularity: 91,
    rating: 4.7,
    duration: "12s",
    useCases: "E-Learning, Kids Apps",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Mia",
    name: "Mia",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Customer Support",
    quality: "PRO",
    desc: "Polite, helpful and corporate-sounding tone.",
    sentence: "For billing inquiries, please press two. For technical support, please hold.",
    compatibility: "XTTS v2",
    popularity: 89,
    rating: 4.6,
    duration: "13s",
    useCases: "IVR, Helpdesks",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Amelia",
    name: "Amelia",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Friendly",
    quality: "Premium",
    desc: "Soft, high-fidelity conversational female speaker.",
    sentence: "Make yourself at home, I'll prepare a hot cup of tea for us.",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.8,
    duration: "15s",
    useCases: "Meditative guides, Vlogs",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Lily",
    name: "Lily",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Podcast",
    quality: "Studio",
    desc: "Smooth, crisp broadcast quality voice.",
    sentence: "Welcome to our live studio session today, with special guests.",
    compatibility: "XTTS v2",
    popularity: 95,
    rating: 4.85,
    duration: "16s",
    useCases: "Podcasts, Radio",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Grace",
    name: "Grace",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Senior",
    style: "Documentary",
    quality: "PRO",
    desc: "Sophisticated and classic narrative voice.",
    sentence: "These majestic species have survived in the wild for thousands of years.",
    compatibility: "XTTS v2, VITS",
    popularity: 90,
    rating: 4.75,
    duration: "18s",
    useCases: "Nature films, Biographies",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Isabella",
    name: "Isabella",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Storytelling",
    quality: "Expressive",
    desc: "Highly emotive and dramatic storyteller.",
    sentence: "She locked the gate behind her, knowing there was no turning back.",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.8,
    duration: "17s",
    useCases: "Drama reads, Storytelling",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Harper",
    name: "Harper",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Corporate",
    quality: "PRO",
    desc: "Confident, crisp, and clean narrator.",
    sentence: "Our next strategy involves launching the product globally.",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.7,
    duration: "14s",
    useCases: "Executive pitches, Corporate presentations",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Scarlett",
    name: "Scarlett",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Storytelling",
    quality: "Expressive",
    desc: "Seductive and deep storytelling voice.",
    sentence: "A mysterious shadow loomed over the castle gates that cold morning.",
    compatibility: "XTTS v2, VITS",
    popularity: 96,
    rating: 4.9,
    duration: "18s",
    useCases: "Audiobooks, Character roles",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Victoria",
    name: "Victoria",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Commercial",
    quality: "Ultra HD",
    desc: "Luxury product commercial speaker.",
    sentence: "Experience elegance and comfort defined by modern craftsmanship.",
    compatibility: "XTTS v2",
    popularity: 95,
    rating: 4.85,
    duration: "15s",
    useCases: "Premium advertisements, Luxury promos",
    recommended: true,
    trending: false,
    isNew: true
  },
  {
    value: "Hannah",
    name: "Hannah",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Customer Support",
    quality: "Human-like",
    desc: "Kind, friendly and patient assistant.",
    sentence: "Please let me know if there's anything else I can do to assist you.",
    compatibility: "XTTS v2",
    popularity: 88,
    rating: 4.6,
    duration: "12s",
    useCases: "IVR prompts, Customer hotlines",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Natalie",
    name: "Natalie",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "News Reader",
    quality: "Premium",
    desc: "Authoritative and objective news anchor voice.",
    sentence: "Market indices surged to record highs today amid positive economic reports.",
    compatibility: "XTTS v2, VITS",
    popularity: 92,
    rating: 4.75,
    duration: "14s",
    useCases: "News broadcasts, Daily briefs",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Zoe",
    name: "Zoe",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "TikTok",
    quality: "Expressive",
    desc: "High energy, enthusiastic vlog host.",
    sentence: "Oh my god guys, you won't believe what just happened today!",
    compatibility: "XTTS v2",
    popularity: 97,
    rating: 4.9,
    duration: "11s",
    useCases: "TikTok, Social media ads",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Aria",
    name: "Aria",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Audiobook",
    quality: "Studio",
    desc: "Rich, literary storytelling narrator.",
    sentence: "The clock struck thirteen as he stepped into the cold corridor.",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.8,
    duration: "20s",
    useCases: "Audiobooks, Classic literature",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Luna",
    name: "Luna",
    gender: "female",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Cinematic",
    quality: "Expressive",
    desc: "Ethereal, dramatic female voice.",
    sentence: "A final light flickered in the distance before the sky went dark.",
    compatibility: "XTTS v2, VITS",
    popularity: 95,
    rating: 4.85,
    duration: "17s",
    useCases: "Cinematic projects, Trailers",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Ryan",
    name: "Ryan",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Clear, authoritative and highly professional narration.",
    sentence: "Innovation distinguishes between a leader and a follower.",
    compatibility: "XTTS v2, VITS",
    popularity: 96,
    rating: 4.9,
    duration: "16s",
    useCases: "Explainer Videos, Business Tutorials",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Ethan",
    name: "Ethan",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Youthful",
    style: "Gaming",
    quality: "Expressive",
    desc: "Fresh, fast and enthusiastic male voice.",
    sentence: "Grab your gear, team! The next match is starting right now.",
    compatibility: "XTTS v2",
    popularity: 95,
    rating: 4.8,
    duration: "10s",
    useCases: "Video Games, Animations",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Liam",
    name: "Liam",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Audiobook",
    quality: "Studio",
    desc: "Slow, calming storytelling voice.",
    sentence: "He walked slowly into the library, looking for the forgotten book.",
    compatibility: "XTTS v2, VITS",
    popularity: 90,
    rating: 4.7,
    duration: "20s",
    useCases: "Audiobooks, Meditation",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "David",
    name: "David",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Clear, mid-range corporate presenter.",
    sentence: "We must align our operational strategies to achieve maximum scalability.",
    compatibility: "XTTS v2",
    popularity: 88,
    rating: 4.6,
    duration: "14s",
    useCases: "Office Training, HR Videos",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "James",
    name: "James",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Cinematic",
    quality: "Ultra HD",
    desc: "Deep, rich, and dramatic male tone.",
    sentence: "In a world where artificial intelligence defines our daily survival.",
    compatibility: "XTTS v2, VITS",
    popularity: 99,
    rating: 4.95,
    duration: "18s",
    useCases: "Movie Trailers, Cinematic Intros",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Noah",
    name: "Noah",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Conversational",
    quality: "Human-like",
    desc: "Relaxed, friendly everyday conversational voice.",
    sentence: "Hey, do you want to grab lunch today and talk about the project?",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.8,
    duration: "12s",
    useCases: "Vlogs, Casual Content",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Michael",
    name: "Michael",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Senior",
    style: "Documentary",
    quality: "Studio",
    desc: "Experienced, informative, historical tone.",
    sentence: "The ruins of the ancient fortress remained undiscovered for centuries.",
    compatibility: "XTTS v2, VITS",
    popularity: 94,
    rating: 4.9,
    duration: "15s",
    useCases: "Documentaries, Historical Narration",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Benjamin",
    name: "Benjamin",
    gender: "male",
    lang: "🇺🇸 English",
    langCode: "en",
    accent: "American Accent",
    age: "Mature",
    style: "Podcast",
    quality: "Premium",
    desc: "Broadcaster style male voice with high fidelity.",
    sentence: "Thanks for joining us on today's panel about futuristic technology.",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.7,
    duration: "16s",
    useCases: "Podcasts, Radio Shows",
    recommended: false,
    trending: true,
    isNew: false
  },

  // ── BRITISH ENGLISH ──
  {
    value: "Charlotte",
    name: "Charlotte",
    gender: "female",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Mature",
    style: "Audiobook",
    quality: "PRO",
    desc: "Classic RP British female voice.",
    sentence: "The garden was filled with roses, lavender, and damp spring soil.",
    compatibility: "XTTS v2",
    popularity: 95,
    rating: 4.8,
    duration: "18s",
    useCases: "Audiobooks, Classic Narrations",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Emma",
    name: "Emma",
    gender: "female",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Youthful",
    style: "Conversational",
    quality: "Human-like",
    desc: "Friendly, modern London accent.",
    sentence: "I reckon we should start the meeting a bit earlier tomorrow.",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.7,
    duration: "11s",
    useCases: "YouTube, Conversational Chatbots",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Sophie",
    name: "Sophie",
    gender: "female",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Professional corporate announcer.",
    sentence: "VoiceForge represents the next generation of generative AI models.",
    compatibility: "XTTS v2",
    popularity: 90,
    rating: 4.6,
    duration: "14s",
    useCases: "E-Learning, Sales Pitches",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Oliver",
    name: "Oliver",
    gender: "male",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Engaging and clear British storyteller.",
    sentence: "A simple idea is often the most powerful catalyst for change.",
    compatibility: "XTTS v2, VITS",
    popularity: 94,
    rating: 4.85,
    duration: "16s",
    useCases: "Explainer Videos, Documentaries",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "George",
    name: "George",
    gender: "male",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Human-like",
    desc: "Gentlemanly corporate trainer.",
    sentence: "We must ensure our security protocols comply with strict regulations.",
    compatibility: "XTTS v2",
    popularity: 87,
    rating: 4.5,
    duration: "15s",
    useCases: "Corporate Training, Tutorials",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "William",
    name: "William",
    gender: "male",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Senior",
    style: "Audiobook",
    quality: "Studio",
    desc: "Deep literary narrator voice.",
    sentence: "The history of England is a story of constant adaptation.",
    compatibility: "XTTS v2, VITS",
    popularity: 91,
    rating: 4.8,
    duration: "19s",
    useCases: "Biographies, Classic Literature",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Arthur",
    name: "Arthur",
    gender: "male",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Senior",
    style: "Documentary",
    quality: "Premium",
    desc: "Prestigious, dry, and informative tone.",
    sentence: "These ancient structures reflect the architectural genius of the epoch.",
    compatibility: "XTTS v2",
    popularity: 89,
    rating: 4.7,
    duration: "15s",
    useCases: "Documentaries, Museum Guides",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "James UK",
    name: "James UK",
    gender: "male",
    lang: "🇬🇧 English",
    langCode: "en",
    accent: "British Accent",
    age: "Mature",
    style: "Cinematic",
    quality: "Ultra HD",
    desc: "Resonant, bold cinematic narrator.",
    sentence: "Behind the shadows of this quiet town, a secret is waiting.",
    compatibility: "XTTS v2, VITS",
    popularity: 96,
    rating: 4.9,
    duration: "17s",
    useCases: "Trailers, Advertisements",
    recommended: true,
    trending: true,
    isNew: true
  },

  // ── AUSTRALIAN ──
  {
    value: "Chloe",
    name: "Chloe",
    gender: "female",
    lang: "🇦🇺 Australian",
    langCode: "en",
    accent: "Australian Accent",
    age: "Youthful",
    style: "TikTok",
    quality: "Expressive",
    desc: "Bright and cheerful Aussie voice.",
    sentence: "Let's head down to the beach and check out the waves!",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.8,
    duration: "11s",
    useCases: "TikTok, Commercials",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Isla",
    name: "Isla",
    gender: "female",
    lang: "🇦🇺 Australian",
    langCode: "en",
    accent: "Australian Accent",
    age: "Mature",
    style: "Conversational",
    quality: "Human-like",
    desc: "Warm and professional Australian female.",
    sentence: "We should focus on building community links this winter.",
    compatibility: "XTTS v2",
    popularity: 89,
    rating: 4.6,
    duration: "14s",
    useCases: "Guides, Casual Podcasts",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Jack",
    name: "Jack",
    gender: "male",
    lang: "🇦🇺 Australian",
    langCode: "en",
    accent: "Australian Accent",
    age: "Mature",
    style: "Podcast",
    quality: "PRO",
    desc: "Friendly, laid-back Australian male.",
    sentence: "G'day mates! Welcome back to the show. Let's get stuck into it.",
    compatibility: "XTTS v2, VITS",
    popularity: 95,
    rating: 4.9,
    duration: "16s",
    useCases: "Podcasts, Vlogs",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Mason",
    name: "Mason",
    gender: "male",
    lang: "🇦🇺 Australian",
    langCode: "en",
    accent: "Australian Accent",
    age: "Mature",
    style: "Narration",
    quality: "Studio",
    desc: "Deep, soothing Australian narrator.",
    sentence: "The great barrier reef hosts thousands of unique marine species.",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.7,
    duration: "17s",
    useCases: "Documentaries, Nature Guides",
    recommended: false,
    trending: false,
    isNew: false
  },

  // ── CANADIAN ──
  {
    value: "Emma CA",
    name: "Emma CA",
    gender: "female",
    lang: "🇨🇦 Canadian",
    langCode: "en",
    accent: "Canadian Accent",
    age: "Youthful",
    style: "Conversational",
    quality: "Premium",
    desc: "Clear, friendly Canadian female.",
    sentence: "I'll be working on this script through the weekend.",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.75,
    duration: "13s",
    useCases: "Commercials, Vlogs",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Lucas CA",
    name: "Lucas CA",
    gender: "male",
    lang: "🇨🇦 Canadian",
    langCode: "en",
    accent: "Canadian Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Human-like",
    desc: "Professional Canadian male.",
    sentence: "We need to ensure project synchronization is completed on time.",
    compatibility: "XTTS v2",
    popularity: 88,
    rating: 4.6,
    duration: "14s",
    useCases: "Corporate Presenter, E-Learning",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Noah CA",
    name: "Noah CA",
    gender: "male",
    lang: "🇨🇦 Canadian",
    langCode: "en",
    accent: "Canadian Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Warm and engaging Canadian narration.",
    sentence: "The northern lights painted the winter night sky with beautiful colors.",
    compatibility: "XTTS v2, VITS",
    popularity: 93,
    rating: 4.8,
    duration: "16s",
    useCases: "Tourism Guides, Audiobooks",
    recommended: true,
    trending: true,
    isNew: true
  },

  // ── HINDI VOICES ──
  {
    value: "Priya",
    name: "Priya",
    gender: "female",
    lang: "🇮🇳 Hindi",
    langCode: "hi",
    accent: "Indian Hindi Accent",
    age: "Mature",
    style: "E-Learning",
    quality: "Human-like",
    desc: "Clear, pleasant and descriptive Indian female.",
    sentence: "आइए हम विभाजन के चरण-दर-चरण नियमों को समझें।",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.8,
    duration: "14s",
    useCases: "Tutorials, Education Content",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Aarav",
    name: "Aarav",
    gender: "male",
    lang: "🇮🇳 Hindi",
    langCode: "hi",
    accent: "Indian Hindi Accent",
    age: "Mature",
    style: "Podcast",
    quality: "PRO",
    desc: "Smooth and highly professional Indian male voice.",
    sentence: "डिजिटल परिवर्तन हमारे आधुनिक व्यावसायिक पारिस्थितिकी तंत्र को नया आकार दे रहा है।",
    compatibility: "XTTS v2, VITS",
    popularity: 96,
    rating: 4.9,
    duration: "15s",
    useCases: "Tech Podcasts, Explainer Videos",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Arjun",
    name: "Arjun",
    gender: "male",
    lang: "🇮🇳 Hindi",
    langCode: "hi",
    accent: "Indian Hindi Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Deep and clear Indian male presentation tone.",
    sentence: "हमें पूर्ण डेटा सुरक्षा सुनिश्चित करने के लिए अपने एपीआई को कॉन्फ़िगर करना होगा।",
    compatibility: "XTTS v2",
    popularity: 90,
    rating: 4.6,
    duration: "15s",
    useCases: "Software Demos, Corporate Pitches",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Kavya",
    name: "Kavya",
    gender: "female",
    lang: "🇮🇳 Hindi",
    langCode: "hi",
    accent: "Indian Hindi Accent",
    age: "Youthful",
    style: "Conversational",
    quality: "Expressive",
    desc: "Friendly, casual and energetic Indian female.",
    sentence: "अरे दोस्तों! आज मैं शीर्ष सॉफ़्टवेयर टूल की समीक्षा करने जा रही हूँ।",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.7,
    duration: "12s",
    useCases: "YouTube, Social Media Ads",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Rahul",
    name: "Rahul",
    gender: "male",
    lang: "🇮🇳 Hindi",
    langCode: "hi",
    accent: "Indian Hindi Accent",
    age: "Mature",
    style: "Customer Support",
    quality: "Premium",
    desc: "Polite and steady customer service assistant.",
    sentence: "आपका टिकट जेनरेट हो गया है। एक प्रतिनिधि जल्द ही आपसे संपर्क करेगा।",
    compatibility: "XTTS v2",
    popularity: 87,
    rating: 4.5,
    duration: "13s",
    useCases: "IVR, Helpline Greetings",
    recommended: false,
    trending: false,
    isNew: false
  },

  // ── 🇵🇰 Dedicated Urdu Voices ──
  {
    value: "Sana",
    name: "Sana",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Professional",
    quality: "PRO",
    desc: "Beautiful, clear and classical Pakistani Urdu female voice.",
    sentence: "ہمارے اس نئے سسٹم میں خوش آمدید، امید ہے آپ کا سفر اچھا رہے گا۔",
    compatibility: "XTTS v2, VITS",
    popularity: 99,
    rating: 4.95,
    duration: "18s",
    useCases: "Poetry Readings, Documentaries, News",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Mahnoor",
    name: "Mahnoor",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Youthful",
    style: "Conversational",
    quality: "Human-like",
    desc: "Friendly and highly interactive Urdu female voice.",
    sentence: "ارے واہ! یہ تو بہت ہی بہترین اور آسان طریقہ کار ہے۔",
    compatibility: "XTTS v2",
    popularity: 97,
    rating: 4.85,
    duration: "12s",
    useCases: "YouTube Vlogs, Interactive AI",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Hira",
    name: "Hira",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Audiobook",
    quality: "Studio",
    desc: "Soft-spoken Lahori Urdu female tone.",
    sentence: "پرانی کتابوں کے پنوں میں ایک عجب سکون اور داستان پوشیدہ ہوتی ہے۔",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.8,
    duration: "20s",
    useCases: "Audiobooks, Storytelling",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Ayesha_Urdu",
    name: "Ayesha",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Professional and articulate Urdu corporate announcer.",
    sentence: "برائے مہربانی اپنا شناختی کارڈ اور دیگر دستاویزات تیار رکھیں۔",
    compatibility: "XTTS v2, VITS",
    popularity: 93,
    rating: 4.75,
    duration: "15s",
    useCases: "Official Announcements, IVR",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Fatima_Urdu",
    name: "Fatima",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Calm",
    quality: "Premium",
    desc: "Extremely soothing, meditative Urdu female.",
    sentence: "سکون حاصل کرنے کے لیے اپنی آنکھیں بند کریں اور گہرا سانس لیں۔",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.7,
    duration: "19s",
    useCases: "Meditation guides, E-learning",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Noor",
    name: "Noor",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Youthful",
    style: "Conversational",
    quality: "Premium",
    desc: "Active and friendly customer assistant voice.",
    sentence: "جی فرمائیے، میں امروز آپ کی کیا مدد کر سکتی ہوں؟",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.8,
    duration: "11s",
    useCases: "IVR systems, AI helpline",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Maryam",
    name: "Maryam",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Senior",
    style: "Documentary",
    quality: "Studio",
    desc: "Experienced, heavy and classical voice profile.",
    sentence: "اس تاریخی عمارت کے پیچھے چھپی داستان صدیوں پرانی ہے۔",
    compatibility: "XTTS v2, VITS",
    popularity: 90,
    rating: 4.65,
    duration: "16s",
    useCases: "Historical reads, Documentaries",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Iqra",
    name: "Iqra",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Youthful",
    style: "Friendly",
    quality: "Human-like",
    desc: "Cheerful, warm and inviting Urdu female host.",
    sentence: "آج ہم اس خوبصورت شہر کی تاریخ کے بارے میں بات کریں گے۔",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.8,
    duration: "13s",
    useCases: "Conversational voiceovers, Vlogs",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Alina",
    name: "Alina",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Corporate",
    quality: "PRO",
    desc: "Elegant and articulate Islamabad female presenter.",
    sentence: "ہمیں اپنی ٹیم کی کارکردگی اور نتائج پر بے حد فخر ہے۔",
    compatibility: "XTTS v2, VITS",
    popularity: 95,
    rating: 4.85,
    duration: "15s",
    useCases: "Corporate presentations, Sales pitches",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Zainab",
    name: "Zainab",
    gender: "female",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Storytelling",
    quality: "Expressive",
    desc: "Highly emotional Lahori Urdu storyteller.",
    sentence: "جیسے ہی سورج غروب ہوا، جنگل میں ایک عجیب خاموشی چھا گئی۔",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.75,
    duration: "17s",
    useCases: "Fables, Story narration",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Ahmed",
    name: "Ahmed",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Podcast",
    quality: "Human-like",
    desc: "Articulate and friendly Pakistani male voice.",
    sentence: "السلام علیکم، ہمارے ہفتہ وار پوڈ کاسٹ میں خوش آمدید۔",
    compatibility: "XTTS v2, VITS",
    popularity: 92,
    rating: 4.7,
    duration: "16s",
    useCases: "Podcasts, Interviews",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Ali",
    name: "Ali",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "News",
    quality: "Studio",
    desc: "Deep and resonant news reader voice.",
    sentence: "آج کی اہم خبریں اور ملکی و بین الاقوامی حالات کا جائزہ۔",
    compatibility: "XTTS v2, VITS",
    popularity: 95,
    rating: 4.9,
    duration: "15s",
    useCases: "Commercials, News reports",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Hamza",
    name: "Hamza",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Smooth, deep, and standard Pakistani Urdu male narrator.",
    sentence: "کامیابی کا دارومدار مسلسل محنت اور ایمانداری پر ہوتا ہے۔",
    compatibility: "XTTS v2, VITS",
    popularity: 98,
    rating: 4.9,
    duration: "16s",
    useCases: "Explainer Videos, Documentaries",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Hassan",
    name: "Hassan",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Professional corporate Urdu male voice.",
    sentence: "ہمیں اپنے پروجیکٹ کے اگلے مرحلے پر کام شروع کرنا چاہیے۔",
    compatibility: "XTTS v2",
    popularity: 89,
    rating: 4.6,
    duration: "15s",
    useCases: "Software Demos, HR Guides",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Bilal",
    name: "Bilal",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Podcast",
    quality: "Human-like",
    desc: "Friendly and highly conversational Lahori male voice.",
    sentence: "آج کے اس پوڈ کاسٹ میں ہم بات کریں گے کہ ڈیجیٹل دور نے ہمیں کیسے بدلا۔",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.7,
    duration: "18s",
    useCases: "Podcasts, Audio Discussions",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Usman",
    name: "Usman",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Senior",
    style: "Documentary",
    quality: "Studio",
    desc: "Experienced and historical Urdu presenter.",
    sentence: "برصغیر کی تاریخ میں اس قلعے کی بہت بڑی عسکری اہمیت رہی ہے۔",
    compatibility: "XTTS v2, VITS",
    popularity: 94,
    rating: 4.85,
    duration: "17s",
    useCases: "Historical Documentaries, Audiobooks",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Fahad",
    name: "Fahad",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Formal corporate Urdu male tone.",
    sentence: "کمپنی کے نئے قوانین اور ضوابط پر عمل کرنا سب کے لیے لازمی ہے۔",
    compatibility: "XTTS v2, VITS",
    popularity: 91,
    rating: 4.6,
    duration: "14s",
    useCases: "Corporate Training, Software Demos",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Zain",
    name: "Zain",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Youthful",
    style: "Gaming",
    quality: "Expressive",
    desc: "Energetic and passionate Lahori Urdu male voice.",
    sentence: "چلو یار! اب اگلا راؤنڈ شروع کرتے ہیں، اس بار ہم جیتیں گے۔",
    compatibility: "XTTS v2",
    popularity: 96,
    rating: 4.8,
    duration: "10s",
    useCases: "Gaming streams, Ads, Youth Promos",
    recommended: true,
    trending: true,
    isNew: true
  },
  {
    value: "Imran",
    name: "Imran",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "Storytelling",
    quality: "PRO",
    desc: "Warm and deep Urdu narrative storyteller.",
    sentence: "ایک دفعہ کا ذکر ہے کہ دور دراز وادی میں ایک نیک دل بادشاہ رہتا تھا۔",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.75,
    duration: "16s",
    useCases: "Storytelling, Audiobooks",
    recommended: false,
    trending: true,
    isNew: true
  },
  {
    value: "Asad",
    name: "Asad",
    gender: "male",
    lang: "🇵🇰 Urdu",
    langCode: "ur",
    accent: "Pakistani Urdu",
    age: "Mature",
    style: "News",
    quality: "Premium",
    desc: "Authoritative and clear Urdu news anchor voice.",
    sentence: "شاہراہوں کی تعمیر نو کا منصوبہ حتمی منظوری کے لیے پیش کر دیا گیا ہے۔",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.7,
    duration: "15s",
    useCases: "News broadcasts, Formal presentations",
    recommended: false,
    trending: false,
    isNew: true
  },

  // ── ARABIC ──
  {
    value: "Omar",
    name: "Omar",
    gender: "male",
    lang: "🇸🇦 Arabic",
    langCode: "ar",
    accent: "Saudi Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Resonant Arabic male voice.",
    sentence: "مرحباً بكم في منصة الصوتيات الأكثر تقدماً في الشرق الأوسط.",
    compatibility: "XTTS v2",
    popularity: 95,
    rating: 4.9,
    duration: "15s",
    useCases: "Documentaries, Corporate",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Layla",
    name: "Layla",
    gender: "female",
    lang: "🇸🇦 Arabic",
    langCode: "ar",
    accent: "Saudi Accent",
    age: "Mature",
    style: "Conversational",
    quality: "Human-like",
    desc: "Clear and warm Arabic female voice.",
    sentence: "كيف يمكنني مساعدتك في ضبط إعدادات الصوت اليوم؟",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.8,
    duration: "12s",
    useCases: "Interactive Systems, E-Learning",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Noor",
    name: "Noor",
    gender: "female",
    lang: "🇸🇦 Arabic",
    langCode: "ar",
    accent: "Egyptian Accent",
    age: "Mature",
    style: "Audiobook",
    quality: "Premium",
    desc: "Soft reading Egyptian Arabic female.",
    sentence: "كانت المدينة القديمة تنبض بالحياة والنشاط في ذلك المساء.",
    compatibility: "XTTS v2",
    popularity: 90,
    rating: 4.7,
    duration: "18s",
    useCases: "Audiobooks, Storytelling",
    recommended: false,
    trending: false,
    isNew: false
  },
  {
    value: "Hassan_AR",
    name: "Hassan_AR",
    gender: "male",
    lang: "🇸🇦 Arabic",
    langCode: "ar",
    accent: "Levantine Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Professional Levantine Arabic male.",
    sentence: "يجب علينا مراجعة الخطط التشغيلية بدقة قبل التنفيذ.",
    compatibility: "XTTS v2",
    popularity: 88,
    rating: 4.6,
    duration: "14s",
    useCases: "Corporate Presentation, Tutorials",
    recommended: false,
    trending: false,
    isNew: false
  },

  // ── GERMAN ──
  {
    value: "Anna",
    name: "Anna",
    gender: "female",
    lang: "🇩🇪 German",
    langCode: "de",
    accent: "Standard German",
    age: "Mature",
    style: "Conversational",
    quality: "PRO",
    desc: "Natural German female narrator.",
    sentence: "Willkommen beim VoiceForge Studio für künstliche Intelligenz.",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.8,
    duration: "14s",
    useCases: "Tutorials, AI Assistants",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Lukas",
    name: "Lukas",
    gender: "male",
    lang: "🇩🇪 German",
    langCode: "de",
    accent: "Standard German",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Clear and precise German male speaker.",
    sentence: "Wir müssen die Effizienz unserer Algorithmen optimieren.",
    compatibility: "XTTS v2",
    popularity: 90,
    rating: 4.7,
    duration: "15s",
    useCases: "E-Learning, Corporate Presenters",
    recommended: false,
    trending: true,
    isNew: false
  },

  // ── FRENCH ──
  {
    value: "Camille",
    name: "Camille",
    gender: "female",
    lang: "🇫🇷 French",
    langCode: "fr",
    accent: "Parisian Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Elegant French female presenter.",
    sentence: "Bienvenue dans le studio de synthèse vocale VoiceForge.",
    compatibility: "XTTS v2",
    popularity: 94,
    rating: 4.85,
    duration: "15s",
    useCases: "Audiobooks, Documentaries",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Louis",
    name: "Louis",
    gender: "male",
    lang: "🇫🇷 French",
    langCode: "fr",
    accent: "Parisian Accent",
    age: "Mature",
    style: "Podcast",
    quality: "Premium",
    desc: "Warm and friendly French male speaker.",
    sentence: "Merci d'avoir écouté cet épisode consacré aux technologies de pointe.",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.7,
    duration: "16s",
    useCases: "Podcasts, Vlogs",
    recommended: false,
    trending: false,
    isNew: false
  },

  // ── SPANISH ──
  {
    value: "Sofia",
    name: "Sofia",
    gender: "female",
    lang: "🇪🇸 Spanish",
    langCode: "es",
    accent: "Castilian Accent",
    age: "Mature",
    style: "Conversational",
    quality: "PRO",
    desc: "Fluid and dynamic Spanish female.",
    sentence: "Bienvenido al futuro de la clonación de voz por inteligencia artificial.",
    compatibility: "XTTS v2",
    popularity: 95,
    rating: 4.9,
    duration: "13s",
    useCases: "AI Assistants, Marketing Video",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Carlos",
    name: "Carlos",
    gender: "male",
    lang: "🇪🇸 Spanish",
    langCode: "es",
    accent: "Mexican Accent",
    age: "Mature",
    style: "Narration",
    quality: "Premium",
    desc: "Clear and warm Latin American Spanish male.",
    sentence: "El éxito requiere constancia, innovación y un equipo dedicado.",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.8,
    duration: "16s",
    useCases: "Commercials, Documentaries",
    recommended: false,
    trending: false,
    isNew: false
  },

  // ── JAPANESE ──
  {
    value: "Haruka",
    name: "Haruka",
    gender: "female",
    lang: "🇯🇵 Japanese",
    langCode: "ja",
    accent: "Standard Japanese",
    age: "Youthful",
    style: "Conversational",
    quality: "PRO",
    desc: "Soft and expressive Japanese female voice.",
    sentence: "音声合成スタジオへようこそ。どのようなテキストを読み上げますか？",
    compatibility: "XTTS v2",
    popularity: 96,
    rating: 4.9,
    duration: "12s",
    useCases: "Anime, Interactive Assistant",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Yuki",
    name: "Yuki",
    gender: "female",
    lang: "🇯🇵 Japanese",
    langCode: "ja",
    accent: "Standard Japanese",
    age: "Youthful",
    style: "Gaming",
    quality: "Premium",
    desc: "Bright, energetic character voice.",
    sentence: "さあ、新しい冒険 of 旅に出発しましょう！準備はいいですか？",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.75,
    duration: "10s",
    useCases: "Gaming, Anime Voiceovers",
    recommended: false,
    trending: false,
    isNew: true
  },

  // ── KOREAN ──
  {
    value: "Jiho",
    name: "Jiho",
    gender: "male",
    lang: "🇰🇷 Korean",
    langCode: "ko",
    accent: "Seoul Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Clear and deep Korean male voice.",
    sentence: "인공지능 음성 합성의 세계에 오신 것을 환영합니다.",
    compatibility: "XTTS v2",
    popularity: 91,
    rating: 4.8,
    duration: "14s",
    useCases: "Explainer Videos, Tutorials",
    recommended: true,
    trending: false,
    isNew: false
  },
  {
    value: "Minji",
    name: "Minji",
    gender: "female",
    lang: "🇰🇷 Korean",
    langCode: "ko",
    accent: "Seoul Accent",
    age: "Youthful",
    style: "Conversational",
    quality: "Premium",
    desc: "Bright and friendly Korean female voice.",
    sentence: "안녕하세요! 오늘 기분은 어떠신가요? 도와드릴까요?",
    compatibility: "XTTS v2",
    popularity: 93,
    rating: 4.85,
    duration: "12s",
    useCases: "Virtual Avatars, Vlogs",
    recommended: false,
    trending: true,
    isNew: true
  },

  // ── CHINESE ──
  {
    value: "Mei",
    name: "Mei",
    gender: "female",
    lang: "🇨🇳 Chinese",
    langCode: "zh-cn",
    accent: "Mandarin Accent",
    age: "Mature",
    style: "Narration",
    quality: "PRO",
    desc: "Clear and standard Mandarin female announcer.",
    sentence: "欢迎来到智能语音合成系统，请在下方输入您的文本。",
    compatibility: "XTTS v2",
    popularity: 97,
    rating: 4.95,
    duration: "15s",
    useCases: "News Broadcasts, E-learning",
    recommended: true,
    trending: true,
    isNew: false
  },
  {
    value: "Wei",
    name: "Wei",
    gender: "male",
    lang: "🇨🇳 Chinese",
    langCode: "zh-cn",
    accent: "Mandarin Accent",
    age: "Mature",
    style: "Corporate",
    quality: "Premium",
    desc: "Professional Mandarin male presenter.",
    sentence: "我们必须坚持以技术创新为导向，提升 product 核心竞争力。",
    compatibility: "XTTS v2",
    popularity: 92,
    rating: 4.7,
    duration: "14s",
    useCases: "Corporate Training, Technical Demos",
    recommended: false,
    trending: false,
    isNew: false
  }
];
